
import { useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import { UserProfile } from '@/types/auth';

export const useUserProfile = () => {
  // Fonction pour charger le profil utilisateur
  const loadUserProfile = useCallback(async (userId: string): Promise<UserProfile | null> => {
    try {
      const { data, error } = await supabase
        .from('users_p')
        .select('*')
        .eq('id', userId)
        .single();

      if (error) {
        console.error('Erreur lors de la récupération du profil:', error);
        return null;
      }

      console.info('Profil utilisateur récupéré:', data);
      return data as UserProfile;
    } catch (error) {
      console.error('Exception dans loadUserProfile:', error);
      return null;
    }
  }, []);

  return { loadUserProfile };
};
